import { useEffect, useRef, useState } from 'react'

import { ApiFehler, api, fehlertext } from '../api'
import type { Benutzer } from '../typen'

/**
 * Der Anmeldeschirm. Vorher hing der Zugang am grauen Kasten des Browsers (Basic Auth): ohne
 * Erklärung, ohne Hinweis bei Tippfehlern, ohne Abmelden. Hier steht, worum es geht, und wer sich
 * vertippt, liest einen Satz statt eines erneuten Kastens.
 */
export default function AnmeldungSeite({ onAngemeldet }: { onAngemeldet: (b: Benutzer) => void }) {
  const [name, setName] = useState('')
  const [passwort, setPasswort] = useState('')
  const [fehler, setFehler] = useState<string | null>(null)
  const [laeuft, setLaeuft] = useState(false)
  const erstes = useRef<HTMLInputElement>(null)

  useEffect(() => erstes.current?.focus(), [])

  async function anmelden(e: React.FormEvent) {
    e.preventDefault()
    if (!name.trim() || !passwort) {
      setFehler('Bitte Benutzername und Passwort eingeben.')
      return
    }
    setLaeuft(true)
    setFehler(null)
    try {
      onAngemeldet(await api.anmelden(name.trim(), passwort))
    } catch (f) {
      setFehler(f instanceof ApiFehler ? f.message : fehlertext(f))
      setPasswort('')
    } finally {
      setLaeuft(false)
    }
  }

  return (
    <div className="anmeldung">
      <form className="karte anmeldung-karte" onSubmit={anmelden}>
        {/* Vor der Anmeldung steht noch kein Bereich fest - welche jemand sieht, hängt am Zugang. */}
        <h1>Othüna</h1>
        <p className="hinweis">
          Verpackungsdisposition und Rohstoffnotierungen. Bitte mit dem persönlichen Zugang anmelden - so steht an
          jeder Buchung, wer sie gemacht hat.
        </p>

        {fehler && (
          <p className="anmeldung-fehler" role="alert">
            {fehler}
          </p>
        )}

        <label className="feld">
          <span>Benutzername</span>
          <input
            ref={erstes}
            type="text"
            value={name}
            autoComplete="username"
            autoCapitalize="none"
            spellCheck={false}
            disabled={laeuft}
            onChange={(e) => setName(e.target.value)}
          />
        </label>
        <label className="feld">
          <span>Passwort</span>
          <input
            type="password"
            value={passwort}
            autoComplete="current-password"
            disabled={laeuft}
            onChange={(e) => setPasswort(e.target.value)}
          />
        </label>

        <button className="haupt" type="submit" disabled={laeuft}>
          {laeuft ? 'Wird geprüft…' : 'Anmelden'}
        </button>
        <p className="hinweis">
          Passwort vergessen oder neuer Zugang nötig? Göran Hegenberg legt ihn an.
        </p>
      </form>
    </div>
  )
}
